$(() => {
  const scrollButtons = $('.ct-button-js-scroll-to');
  if (!scrollButtons.length) {
    return;
  }
  const header = $('header');
  if (!header.length) {
    return;
  }
  const headerHeight = header.outerHeight();
  const targetElement = $('.ct-section-js-scroll-to');
  if (!targetElement.length) {
    return;
  }
  scrollButtons.on('click', function(event) {
    event.preventDefault();
    const targetPosition = targetElement.offset().top - headerHeight;
    $('html, body').animate({
      scrollTop: targetPosition
    }, 'slow');
  });
});